export default "__VITE_ASSET__9ef108f1__"